/* global APP */
import configs from "./utils/configs";

export default async function mintNft(url) {
  const nftMarketplaceUrl = configs.NFT_MARKETPLACE_URL;

  if (!APP.hubChannel.signedIn) {
    document.querySelector("a-scene")?.emit("action_media_nft_mint");

    return;
  }

  try {
    APP.messageDispatch.receive({
      type: "custom",
      name: "",
      action: "Opening NFT Marketplace, please wait...",
      object: "",
      imageUrl: null,
      externalUrl: null
    });

    window.open(`${nftMarketplaceUrl}/nfts/metaverse-mint?url=${url}`, "_blank").focus();
  } catch (err) {
    console.error(err);
    APP.messageDispatch.receive({
      type: "custom",
      name: "",
      action: "Error while minting the NFT",
      object: "",
      imageUrl: null,
      externalUrl: null
    });
  }
}
